export const DEFAULT_BUNDLES = {
    "5": 1,
    "10": 3,
    "20": 8,
    "50": 25,
    "100": 60
}

export const DEFAULT_STYLES = {
    background: "",
    backgroundOverlayColor: "#000000",
    backgroundOverlayOpacity: 0,
    bodyTxt: "#ffffff",
    livePrizePoolLabelBg: "#0f766e",
    livePrizePoolLabelTxt: "#ffffff",
    skin: "classic",
    logo: "",
    logoBg: "",
    logoFrame: "none",
    logoOffsetX: 0,
    logoOffsetY: 0,
    logoScale: 1,
    primaryBtnBg: "#0f766e",
    primaryBtnTxt: "#ffffff",
    secondaryBtnBorder: "1px solid #ffffff",
    secondaryBtnTxt: "#ffffff",
    splitPrizeBg: "#ffffff",
    splitPrizeTxt: "#0f172a",
    success: "https://s50-events-assets.s3-ap-southeast-2.amazonaws.com/check-mark.png",
    ticketsSoldTxt: "#0f766e"
}

export function blankClient() {
    return {
        PK: "",
        SK: "",
        altPromo: "",
        bundles: { ...DEFAULT_BUNDLES },
        charity: "",
        charityAlt: "",
        currentEvent: "",
        defaultMaxPrize: 2000,
        email: "",
        eventCount: 0,
        name: "",
        optInMessage: "",
        promoMessage: "",
        rolling: false,
        stub: "",
        styles: { ...DEFAULT_STYLES },
        terms: ""
    }
}

export function cloneClient(client) {
    return JSON.parse(JSON.stringify(client))
}
